
// Use RAILS_ENV instead of NODE_ENV
// NODE_ENV is always production on heroku.

export function isProduction() {
  return process.env.RAILS_ENV === 'production';
}
